export default {"src":"/_next/static/media/aura-profile.ffd78c2a.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};